import React from 'react';
import Immutable from 'immutable';
import styled from 'styled-components';
import Box from '../../components/containers/box';
import Button from '../../components/forms/button';
import { getColumnText, getPhrase } from '../../data/phrases';
import FlexBox from '../../components/containers/flexbox';
import FlexBoxBlock from '../../components/containers/flexboxblock';
import memoizeOne from 'memoize-one';
import $ from 'jquery';


const getSelectedColumnSet = memoizeOne(selectedColumns => Immutable.Set(selectedColumns));

const getAvailableColumns = memoizeOne((availableColumns, selectedColumns) => {
	const selColSet = getSelectedColumnSet(selectedColumns);
	return availableColumns.filter(col => !selColSet.has(col));
});


export default class ColumnListEditor extends React.PureComponent {
	constructor() {
		super();
		this.onOk = this.onOk.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.dragEnd = this.dragEnd.bind(this);
		this.onUnselectAll = this.onUnselectAll.bind(this);
	}

	onOk() {
		this.props.onCloseRequested(true);
	}

	onCancel() {
		this.props.onCloseRequested(false);
	}


	dragEnd(e) {
		e.target.classList.remove('dragged');
		//$(e.target).closest('.columnListEditor').find('.dragHover').removeClass('dragHover');
	}

	onUnselectAll() {
		this.props.removeAllColumns();
	}

	render() {
		const data = this.props.data;
		const entityName = data.get('entityName');
		const selectedColumns = data.get('selectedColumns');
		const availableColumns = getAvailableColumns(data.get('availableColumns'), selectedColumns);
		return (
			<Wrapper className="columnListEditor">
				<FlexBox vertical>
					<FlexBoxBlock flexGrow="1">
				<FlexBox>
					<FlexBoxBlock flexGrow="1" padding="8px" width="50%">
						<FlexBox vertical>
						<Header>{getPhrase('availableColumns')}</Header>
						<AvailableColumns
							className="availableColumns"
							onDragOver={e => {
								e.preventDefault();
							}}
							onDragEnter={e => {
								e.preventDefault();
								e.target.classList.add('dragHover');
							}}
							onDrop={e => {
								if (e.defaultPrevented) {
									return;
								}
								e.preventDefault();
								const col = e.dataTransfer.getData('text');
								e.target.classList.remove('dragHover');
								this.props.removeColumn(col);
							}}

						>
							{
								availableColumns.map((col, index) => {
									return (
										<AvailableColumn
											key={col}
											data-name={col}
											draggable
											onDragStart={e => {
												e.target.classList.add('dragged');
												e.dataTransfer.setData('text', col);
												e.dataTransfer.effectAllowed = 'move';
											}}
											onDragEnd={this.dragEnd}
										>
											{getColumnText(col, entityName)}
										</AvailableColumn>
									);
								})
							}
						</AvailableColumns>
						</FlexBox>
					</FlexBoxBlock>
					<FlexBoxBlock flexGrow="1" padding="8px" width="50%">
						<FlexBox vertical>
						<Header>{getPhrase('selectedColumns')}</Header>
						<SelectedColumns
							className="selectedColumns"
							onDragEnter={e => {
								e.preventDefault();
								e.target.classList.add('dragHover');
							}}
							onDragOver={e => {
								e.preventDefault();
							}}
							onDragLeave={e => {
								e.target.classList.remove('dragHover');
							}}
							onDrop={e => {
								if (e.defaultPrevented) {
									return;
								}
								e.preventDefault();
								e.target.classList.remove('dragHover');
								const source = e.dataTransfer.getData('text');
								this.props.moveColumnBefore(source, null);
							}}
						>
							{
								selectedColumns.map((col, index) => {
									return (
										<SelectedColumn
											key={col}
											draggable
											data-name={col}
											onDragEnter={e => {
												e.preventDefault();
												e.target.classList.add('dragHover');
											}}
											onDragOver={e => {
												e.preventDefault();
											}}
											onDragLeave={e => {
												e.target.classList.remove('dragHover');
											}}
											onDragEnd={this.dragEnd}
											onDragStart={e => {
												e.target.classList.add('dragged');
												e.dataTransfer.setData('text', col);
												e.dataTransfer.effectAllowed = 'move';
											}}
											onDrop={e => {
												e.preventDefault();
												e.target.classList.remove('dragHover');
												const source = e.dataTransfer.getData('text');
												this.props.moveColumnBefore(source, col);
											}}
										>
											{getColumnText(col, entityName)}
										</SelectedColumn>
									);
								})
							}
							<SelectedColumn
								className="dummy"
								onDragEnter={e => {
									e.preventDefault();
									e.target.classList.add('dragHover');
								}}
								onDragOver={e => {
									e.preventDefault();
								}}
								onDrop={e => {
									e.preventDefault();
									e.target.classList.remove('dragHover');
									const source = e.dataTransfer.getData('text');
									this.props.moveColumnBefore(source, null);
								}}
								onDragLeave={e => {
									e.target.classList.remove('dragHover');
								}}
							>{'\u00A0'}</SelectedColumn>
						</SelectedColumns>
						</FlexBox>
					</FlexBoxBlock>
				</FlexBox>
					</FlexBoxBlock>
					<FlexBoxBlock>
				<Buttons>
					<FlexBox>
						<FlexBoxBlock flexGrow="1">
							<Button
								text={getPhrase('unselectAll')}
								type="light"
								onAction={this.onUnselectAll}
							/>

						</FlexBoxBlock>
						<FlexBoxBlock>
							<Button
								text={getPhrase('cancel')}
								type="light"
								onAction={this.onCancel}
							/>
							<Button
								text={getPhrase('ok')}
								onAction={this.onOk}
							/>

						</FlexBoxBlock>
					</FlexBox>
				</Buttons>
				</FlexBoxBlock>
				</FlexBox>
			</Wrapper>
		)
	}
}

const Wrapper = styled.div`
	position: absolute;
	height: 90%;
	width: 600px;
	max-width: 90%;
	top: 5%;
	left: 50%;
	transform: translateX(-50%);
	border: ${props => props.theme.boxBorder};
	border-radius: ${props => props.theme.boxBorderRadius};
	padding: ${props => props.boxPadding || props.theme.boxPadding};
	background: ${props => props.theme.boxBackground};

`;

const Header = styled.div`
	font-weight: 700;
	padding: 2px;
`;

const Buttons = styled.div`
	.ps-button {
		margin-left: 16px;
	}
`;

const AvailableColumns = styled.div`
	padding: 4px;
	overflow: auto;
	flex-grow: 1;
	background: ${props => props.theme.inputBackground};
	border: ${props => props.theme.inputBorder};

`;

const AvailableColumn = styled.div`
	padding: 2px 4px;
	cursor: grab;
	background: ${props => props.theme.inputBackground};
	&.dragged {
		transition: 0.01s;
		transform: translateX(-9999px);
	}
	&:hover:not(.dummy) {
		background: ${props => props.theme.tableRowHoverBackground};
	}

`;

const SelectedColumns = styled.div`
	padding: 4px;
	flex-grow: 1;
	overflow: auto;
	background: ${props => props.theme.inputBackground};
	border: ${props => props.theme.inputBorder};
	&.dragHover {
		.dummy {
			border-top: 2px solid gray;
		}
	}

`;

const SelectedColumn = styled.div`
	padding: 2px 4px;
	cursor: grab;
	background: ${props => props.theme.inputBackground};
	&:hover:not(.dummy) {
		background: ${props => props.theme.tableRowHoverBackground};
	}
	&.dummy {
		color: rgb(0, 0, 0, 0);
	}
	&.dragged {
		transition: 0.01s;
		transform: translateX(-9999px);
	}

	&.dragHover {
		border-top: 2px solid gray;
	}
`;
